
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/datatable/datatable.component.js'
      import type { DdsSortingChangeEvent } from '../../events/events'
import type { DdsSelectionChangeEvent } from '../../events/events'
import type { DdsPaginationChangeEvent } from '../../events/events'
import type { DdsRowClickEvent } from '../../events/events'
      export type { DdsSortingChangeEvent } from '../../events/events'
export type { DdsSelectionChangeEvent } from '../../events/events'
export type { DdsPaginationChangeEvent } from '../../events/events'
export type { DdsRowClickEvent } from '../../events/events'

      const tagName = 'dap-ds-datatable'

      /**
 * `dap-ds-datatable`
 * @summary A data table is a component that displays data in a tabular format.
 * @element dap-ds-datatable
 * @title - Data table
 * @generic T
 *
 * @event {{ sorting: SortingState }} dds-sorting-change - Fired when the sorting of the table changes.
 * @event {{ selection: RowSelectionState }} dds-selection-change - Fired when the selection of the table changes.
 * @event {{ pagination: PaginationState }} dds-pagination-change - Fired when the pagination of the table changes.
 * @event {{ row: Row<T> }} dds-row-click - Fired when a row is clicked.
 *
 * @csspart base - The main table container.
 * @csspart header - The header of the table.
 * @csspart header-row - The header row of the table.
 * @csspart header-cell - All cells of the header.
 * @csspart body - The body of the table.
 * @csspart row - All rows of the table.
 * @csspart cell - All cells of the table.
 * @csspart pager - The pager of the table.
 *
 * @cssproperty --dds-datatable-bg-color - Background color of the table
 * @cssproperty --dds-datatable-border-color - Border color of the table cells
 * @cssproperty --dds-datatable-header-bg-color - Background color of the table header
 * @cssproperty --dds-datatable-header-text-color - Text color of the table header
 * @cssproperty --dds-datatable-row-hover-bg-color - Background color of hovered rows
 * @cssproperty --dds-datatable-row-selected-bg-color - Background color of selected rows
 * @cssproperty --dds-datatable-cell-padding - Padding of table cells
 * @cssproperty --dds-datatable-header-padding - Padding of header cells
 * @cssproperty --dds-datatable-border-width - Width of table borders
 * @cssproperty --dds-datatable-font-size - Font size of the table
 * @cssproperty --dds-datatable-line-height - Line height of the table
 * @cssproperty --dds-datatable-header-font-weight - Font weight of the header
 * @cssproperty --dds-datatable-stripe-color - Background color for striped rows
 * @cssproperty --dds-datatable-stripe-enabled - Whether to enable striped rows
 * @cssproperty --dds-datatable-border-radius - Border radius of the table
 * @cssproperty --dds-datatable-shadow - Box shadow of the table
 * @cssproperty --dds-datatable-transition-duration - Duration of hover/selection transitions
 * @cssproperty --dds-datatable-z-index - Z-index of the table
 * @cssproperty --dds-datatable-min-height - Minimum height of the table
 * @cssproperty --dds-datatable-max-height - Maximum height of the table
 * @cssproperty --dds-datatable-overflow-x - Horizontal overflow behavior
 * @cssproperty --dds-datatable-overflow-y - Vertical overflow behavior
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsSortingChange: 'dds-sorting-change' as EventName<DdsSortingChangeEvent>,
onDdsSelectionChange: 'dds-selection-change' as EventName<DdsSelectionChangeEvent>,
onDdsPaginationChange: 'dds-pagination-change' as EventName<DdsPaginationChangeEvent>,
onDdsRowClick: 'dds-row-click' as EventName<DdsRowClickEvent>
        },
        displayName: "DapDSDataTable"
      })

      export default reactWrapper
    